import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=5c1caef6&scoped=true&"
import script from "./ProfileDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileDetail.vue?vue&type=script&lang=js&"
import style1 from "./ProfileDetail.vue?vue&type=style&index=1&id=5c1caef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1caef6",
  null
  
)

export default component.exports